<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
    <flash-message transitionIn="animated swing" class="myCustomClass" style="position: absolute;right: 15px;top: 60px;z-index: 99;max-width: 300px;margin: auto;"></flash-message>
    <loading></loading>
  </div>
</template>


<style lang="scss">
  @import "./assets/css/app.scss";
</style>

<script>
import loading from '@/components/elements/loading'

export default {
  name: 'app',
  components: {
  	loading : loading,
  }
}
</script>

<style scroped>
  
</style>



// WEBPACK FOOTER //
// src/App.vue